<!-- Drilldown Grid — mirrors AngularJS form-view-tab.html + grid-standard-tab-list -->

<!-- Tab strip (only when showTabBar is true; parent may render its own tab bar) -->
@if (showTabBar && (tabs.length > 0 || !formReviewActive)) {
  <div class="drilldown-tab-bar" [ngClass]="currentTheme">
    <ul class="nav nav-tabs drilldown-tabs">
      <li [class.active]="formReviewActive">
        <a (click)="goToFormReview()" class="tab-link">
          <i class="fa fa-file-pdf-o"></i> Form Review
        </a>
      </li>
      @for (tab of tabs; track tab) {
        <li [class.active]="tab.active">
          <a (click)="activateTab(tab)" class="tab-link">
            {{ tab.name }}
            <i class="fa fa-times tab-close" (click)="closeTab(tab, $event)"></i>
          </a>
        </li>
      }
    </ul>
  </div>
}

<!-- Grid panel for active drilldown tab (renders independently of showTabBar) -->
@if (activeTab && !formReviewActive) {
  <div class="drilldown-grid-panel" [ngClass]="currentTheme">
    <!-- Legacy form-view-tab.html: pdf-details header (single row; no dashboard toolbar above) -->
    <div class="pdf-details">
      <div class="details-view-header">
        <div class="form-details">
          <span class="pdf-icon"><i class="fa fa-file-pdf-o"></i></span>
          <span>LE Name: <span class="values">{{ activeTab.data?.leName }}</span></span>
          <span>Form: <span class="values">{{ activeTab.data?.form }}</span></span>
          <span>Schedule: <span class="values">{{ formatHeaderField(activeTab.data?.schedule) }}</span></span>
          <span>Line: <span class="values">{{ activeTab.data?.line }}</span></span>
          <span>Col: <span class="values">{{ formatHeaderField(activeTab.data?.colId) }}</span></span>
        </div>
        @if (hasLineTotal()) {
          <div class="line-count-box">
            <div class="section"><span class="box-label inline-block">Line Total</span></div>
            <div class="section section-color">
              <span class="num values inline-block">{{ formatLineTotal(activeTab.data.lineTotal) }}</span>
            </div>
          </div>
        }
      </div>
      <!-- Legacy note is commented out in AngularJS; kept hidden for parity -->
      <!--
      <div class="details-view-header warning-msg-container">
        <span class="warning-msg">
          Note: Form data is in Form sign. Drill down data in the grid is in Debit/Credit format.
        </span>
      </div>
      -->
      <div class="drilldown-grid-body">
        <div class="drilldown-grid-host">
          <div adminGrid
            [gridConfig]="activeTab.gridConfig"
            (gridCallback)="onGridCallback($event)"
            (gridDataLoaded)="onGridDataLoaded($event)"
            (loadingStateChange)="onLoadingStateChange($event)"
            class="gizmo-grid drilldown-gizmo-grid"
            tabindex="2">
          </div>
        </div>
        @if (activeTab.loading) {
          <div class="drilldown-loader">
            <i class="fa fa-spinner fa-spin"></i> Loading data...
          </div>
        }
      </div>
    </div>
  </div>
}
